<template>
  <div class="mt-4 mr-2">
    <div v-if="loading" class="text-sm text-gray-400 py-2">Загрузка...</div>
    <template v-else>
      <!-- Прогрессбар -->
      <div class="mb-3">
        <div class="flex items-center justify-between mb-1">
          <span class="text-sm font-medium text-gray-700">
            Распределено: {{ distributedCount }} из {{ totalCount }}
          </span>
          <span class="text-sm text-gray-500">{{ progressPercent }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2">
          <div
            class="h-2 rounded-full transition-all duration-300"
            :class="progressPercent >= 100 ? 'bg-green-500' : 'bg-blue-500'"
            :style="{ width: progressPercent + '%' }"
          ></div>
        </div>
      </div>

      <!-- Места -->
      <div v-if="places.length === 0" class="text-sm text-gray-400">Нет упаковочных мест</div>
      <div v-else class="space-y-2">
        <div
          v-for="place in places"
          :key="place.id"
          class="bg-white border rounded-lg shadow-sm"
        >
          <div class="flex items-center justify-between px-3 py-2 bg-gray-50 rounded-t-lg">
            <div class="flex items-center gap-2">
              <span class="font-semibold text-sm">Место #{{ place.number }}</span>
              <span class="text-xs text-gray-500">({{ place.items?.length || 0 }} поз.)</span>
            </div>
            <div class="flex items-center gap-2 text-xs text-gray-500">
              <span v-if="place.dimensions">{{ place.dimensions }}</span>
              <span v-if="place.weight_gross">{{ place.weight_gross }} кг</span>
            </div>
          </div>
          <div class="px-3 py-1.5">
            <div v-if="!place.items || place.items.length === 0" class="text-xs text-gray-400 py-1 text-center">
              Нет позиций
            </div>
            <div v-else class="divide-y">
              <div
                v-for="item in place.items"
                :key="item.id"
                class="flex items-center justify-between py-1"
              >
                <div class="flex-1 min-w-0">
                  <div class="text-xs truncate">{{ item.product?.name || '' }}</div>
                  <div v-if="item.serial_number || item.batch_product?.serial_number" class="text-xs text-blue-600">
                    S/N: {{ item.serial_number || item.batch_product?.serial_number }}
                  </div>
                </div>
                <div class="text-xs text-gray-500 ml-2 whitespace-nowrap">
                  <span>×{{ item.quantity }} {{ item.product?.unit?.short_name || 'шт' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PackingPlacesSummary',
  props: {
    taskId: { type: [String, Number], required: true },
  },
  data() {
    return {
      loading: false,
      materials: [],
      places: [],
    };
  },
  computed: {
    computedMaterials() {
      const distributed = {};
      for (const place of this.places) {
        for (const item of place.items || []) {
          distributed[item.product_id] = (distributed[item.product_id] || 0) + parseFloat(item.quantity);
        }
      }
      return this.materials.map(m => ({
        ...m,
        distributed_quantity: distributed[m.product_id] || 0,
      }));
    },
    totalCount() {
      // Счётчик распределения считается по плану упаковочной спецификации
      return this.materials.reduce((sum, m) => sum + parseFloat(m.required_quantity || 0), 0);
    },
    distributedCount() {
      return this.computedMaterials.reduce((sum, m) => sum + m.distributed_quantity, 0);
    },
    progressPercent() {
      if (this.totalCount === 0) return 0;
      return Math.min(100, Math.round((this.distributedCount / this.totalCount) * 100));
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const [materialsRes, placesRes] = await Promise.all([
          axios.post('/api/packingPlace/getOrderMaterials', { production_task_id: this.taskId }),
          axios.post('/api/packingPlace/getPackingPlaces', { production_task_id: this.taskId }),
        ]);
        this.materials = materialsRes.data.data || [];
        this.places = placesRes.data.data || [];
      } catch (error) {
        console.error('Ошибка загрузки упаковочных мест:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
